import { Location } from 'history';
import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { SDialogButton } from './common/BCommonComponents';


interface Props {
	when?: boolean | undefined;
	navigate: (path: string) => void;
	shouldBlockNavigation: (location: Location) => boolean;
	message: string;
}

const RouteLeavingGuard = ({
														 when,
														 navigate,
														 shouldBlockNavigation,
														 message
													 }: Props) => {
	const [modalVisible, setModalVisible] = useState(false);
	const [lastLocation, setLastLocation] = useState<Location | null>(null);
	const [confirmedNavigation, setConfirmedNavigation] = useState(false);
	const closeModal = () => {
		setModalVisible(false);
	};

	const handleBlockedNavigation = (nextLocation: Location): boolean => {
		if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
			setModalVisible(true);
			setLastLocation(nextLocation);
			return false;
		}
		return true;
	};

	useEffect(() => {
		if (confirmedNavigation && lastLocation) {
			// Navigate to the previous blocked location with your navigate function
			navigate(lastLocation.pathname);
		}
	}, [confirmedNavigation, lastLocation]);

	return (
		<>
			<Prompt when={when} message={handleBlockedNavigation} />      {/* Your own alert/dialog/modal component */}
			<AlertDialog
				open={modalVisible}
				onCancel={closeModal}
				message={message}
			/>    </>
	);};

export default RouteLeavingGuard;

export interface DialogProps {
	open: boolean;
	onCancel: () => void;
	message: string;
}

function AlertDialog(props: DialogProps) {
	const {open, onCancel, message} = props;

	const handleCancel = () => {
		onCancel();
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleCancel}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"ATTENZIONE"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<SDialogButton onClick={handleCancel}>
						OK
					</SDialogButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}